import { createFileRoute } from '@tanstack/react-router';
import UserGroupMembers from '../../../administration/src/components/UserGroups/UserGroupDetails/UserGroupMembers';

export const Route = createFileRoute('/_secured/administration/user-groups/$groupId/members/$page/$limit')({
  component: UserGroupMembers,
});
